module.exports = __webpack_public_path__ + "media/photo/AdobeStock_238252796-1e176268.png";